import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { Organization } from 'models/organization';
import { SimpleOrderContext } from 'pages/order-flow/simple-order/simple-order-context';
import { LabClient } from 'models/client-directory';
import Loader from 'components/shared/loader/loader.component';
import { useLazyQuery } from '@apollo/client';
import { connectedLabsForClinicTemplate } from 'apollo/templates/organization';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import CustomerGridItem from '../customer-grid-item/customer-grid-item.component';
import { Grid } from '@mui/material';

type CustomerGridProps = {
    initialValue?: Organization;
    isEdit: boolean;
};

const CustomerGrid: FC<CustomerGridProps> = ({ initialValue, isEdit }) => {
    const { order: simpleOrder, setOrder: setSimpleOrder } = useContext(SimpleOrderContext);
    const [selectedLab, setSelectedLab] = useState<Partial<Organization>>();
    const [clientLabs, setClientLabs] = useState<LabClient[]>([]);
    const { showBoundary } = useDenthubErrorBoundary();

    const [connectedLabsForClinic, { loading }] = useLazyQuery(connectedLabsForClinicTemplate, {
        onCompleted: async ({ connectedLabsForClinic }) => {
            setClientLabs(connectedLabsForClinic);
        },
        onError(error) {
            showBoundary(error);
        },
    });

    useEffect(() => {
        connectedLabsForClinic();
    }, []);

    useEffect(() => {
        setSelectedLab(initialValue);
    }, [initialValue]);

    const handleSelectLab = (lab: Organization) => {
        setSelectedLab(lab);
        setSimpleOrder({
            ...simpleOrder,
            supplier: lab,
        });
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <Grid container spacing={2} alignItems="stretch">
            {clientLabs.map((clientLab) => {
                const lab = clientLab.lab as Organization;
                const isSelected = selectedLab?._id === lab._id;
                return (
                    <Fragment key={clientLab._id}>
                        {(!isEdit || isSelected) && (
                            <CustomerGridItem lab={lab} isSelected={isSelected} handleLabSelect={handleSelectLab} />
                        )}
                    </Fragment>
                );
            })}
        </Grid>
    );
};

export default CustomerGrid;
